import { css } from "@/domains/emotion";
import { SettingsAccountMigrationDebugSection } from "@/pages/settings/components/settings-account-migration-debug-section";
import { SettingsAccountMigrationImporterSection } from "@/pages/settings/components/settings-account-migration-importer-section";
import { SettingsAccountMigrationV2Section } from "@/pages/settings/components/migration/migration-section";
import {
  SettingsIntegrationPageWrapper,
  SettingsIntegrationHeader,
  SettingsIntegrationScrollableArea,
  SettingsIntegrationSection,
} from "@/pages/settings/components/settings-integration-layout";
import { useAppStore } from "@/store";
import { observer } from "mobx-react-lite";
import { FC } from "react";

export const SettingsAccountMigrationPage: FC = observer(() => {
  const { store } = useAppStore();
  const isMigrationInProgress = store.dataImports.isMigrationStarted;

  if (isMigrationInProgress) {
    return (
      <SettingsIntegrationPageWrapper>
        <SettingsIntegrationHeader breadcrumb="Account" title="Migration from Mem 1.0 to 2.0" />
        <SettingsIntegrationScrollableArea>
          <SettingsIntegrationSection>
            <div className={importWrapperStyle}>
              <SettingsAccountMigrationV2Section />
            </div>
          </SettingsIntegrationSection>
        </SettingsIntegrationScrollableArea>
      </SettingsIntegrationPageWrapper>
    );
  }

  return (
    <SettingsIntegrationPageWrapper>
      <SettingsIntegrationHeader breadcrumb="Account" title="Import from Mem 1.0" />
      <SettingsIntegrationScrollableArea>
        <SettingsIntegrationSection>
          <div className={importWrapperStyle}>
            <SettingsAccountMigrationImporterSection />
            <SettingsAccountMigrationDebugSection />
          </div>
        </SettingsIntegrationSection>
      </SettingsIntegrationScrollableArea>
    </SettingsIntegrationPageWrapper>
  );
});

export const importWrapperStyle = css({
  fontSize: 14,
  lineHeight: "20px",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
});
